<template>
    <div class="kt-header--fixed hide-on-mobile">
        <div class="kt-header">
            <div class="kt-header__top kt-header__top--mobile">
                <v-navigation-drawer v-if="$vuetify.breakpoint.smAndDown" v-model="drawer" app temporary right flat width="320" class="overflow-visible mobile-vertical-navigation" style="top: 60px; height: calc(100% - 60px); background-color: var(--primary-background) !important;">
                    <v-list dense nav color="transparent">
                        <v-row>
                            <BadgeNavigation :is-mobile="isMobile" />
                        </v-row>
                        <v-row class="px-6">
                            <template v-for="(item, index) in menuItems">
                                <!-- Items that enjoy life -->
                                <v-list-item v-if="!item.children" :key="`item-${index}`">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <router-link v-if="item.name" :to="buildRoute(item)">{{item.label}}</router-link>
                                            <a v-else :href="item.url">{{item.label}}</a>
                                            <img v-if="item.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 5px;" />
                                            <v-divider :class="isActive(item) ? 'active-tab ' : 'inactive-tab'" class="my-1"/>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <!-- Items with children -->
                                <v-list-group v-else :key="`group-${index}`" no-action class="w-100">
                                <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{item.label}}
                                            <img v-if="item.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 5px;" />
                                            <v-divider class="my-1" :class="item.children && item.children.some(child => child.children ? child.children.some(grandchild => isActive(grandchild)) : isActive(child)) ? 'active-tab' : 'inactive-tab'"/>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </template>

                                <!-- Children -->
                                <template v-for="(child, childIndex) in item.children">
                                    <!-- Orphan child -->
                                    <v-list-item v-if="!child.children" :key="`child-${index}-${childIndex}`" class="ml-4">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <router-link v-if="child.name" :to="buildRoute(child)">{{child.label}}</router-link>
                                                <a v-else :href="child.url">{{ child.label }}</a>
                                                <img v-if="child.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 5px;" />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <!-- Child with grandchildren -->
                                    <v-list-group v-else :key="`subgroup-${index}-${childIndex}`" sub-group class="mx-4">
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title>{{child.label}}</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-icon>mdi-chevron-down</v-icon>
                                            </v-list-item-action>
                                        </template>

                                        <!-- Grandchildren -->
                                        <v-list-item v-for="(grandchild, grandIndex) in child.children" :key="`grand-${index}-${childIndex}-${grandIndex}`" class="ml-8">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-icon small>mdi-minus</v-icon>
                                                    <router-link v-if="grandchild.name" :to="buildRoute(grandchild)"><span class="text-wrap">{{grandchild.label}}</span></router-link>
                                                    <a v-else :href="grandchild.url"><span class="text-wrap">{{grandchild.label}}</span></a>
                                                    <img v-if="grandchild.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 5px;" />
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-group>
                                </template>
                                </v-list-group>
                            </template>
                        </v-row>
                    </v-list>
                </v-navigation-drawer>
                <v-row class="ma-0 kt-header__top mobile-horizontal-navigation">
                    <template v-if="isMobile !== true">
                        <v-col :style="$vuetify.breakpoint.mdAndUp ? 'padding: 12px 12px 12px 24px;' : ''">
                            <router-link :to="{ name: 'dashboard' }">
                                <!-- TODO: Add Brand name to alt-->
                                <img alt="" :src="platform === 'housejet' ? '/images/logos/housejet/housejet.png' : $vuetify.breakpoint.mdAndDown ? '/brandingThumbnailLogo' : '/brandingLogo'" class="display-block" style="height: 45px;" />
                            </router-link>
                        </v-col>
                    </template>
                    <template v-if="isMobile && hasToken">
                        <v-col>
                        <v-btn :to="{name: 'dashboard'}" icon large color="secondary">
                            <v-icon>mdi-home</v-icon>
                        </v-btn>
                        </v-col>
                    </template>
                    <template v-if="isMobile && hasToken">
                        <v-col>
                        <v-btn :to="{name: 'user-list'}" icon large color="secondary">
                            <v-icon>mdi-account</v-icon>
                        </v-btn>
                        </v-col>
                    </template>
                    <template v-if="isMobile && hasToken">
                        <v-col>
                        <v-btn :to="{name: 'pipeline'}" icon large color="secondary">
                            <v-icon>mdi-pipe</v-icon>
                        </v-btn>
                        </v-col>
                    </template>
                    <template v-if="isMobile && hasToken">
                        <v-col>
                        <v-btn :to="{name: 'notifications'}" icon large color="secondary">
                            <v-icon>mdi-bell</v-icon>
                        </v-btn>
                        </v-col>
                    </template>
                    <template v-if="(!isMobile && $vuetify.breakpoint.smAndDown) || (isMobile && hasToken)">
                        <v-col>
                        <v-btn @click="toggleDrawer" icon large color="secondary" :ripple="false" :class="{'float-right' : !isMobile}">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                        </v-col>
                    </template>
                    <template v-if="(!isMobile && !$vuetify.breakpoint.smAndDown)">
                        <v-col>
                            <div class="kt-header-menu">
                                <v-list color="transparent" class="kt-menu__nav d-flex flex-row pt-0" dense nav>
                                    <template v-for="(item, index) in menuItems" v-if="item.MobileOnly !== true">
                                        <v-list-item v-if="!item.children" :key="`item-${index}`" class="kt-menu__item" :id="`_header_menu_${item.label.toLowerCase().replace(/\s+/g, '_')}`">
                                            <v-list-item-content class="kt-menu__link">
                                                <v-list-item-title>
                                                    <router-link v-if="item.name" :to="buildRoute(item)">{{item.label}}</router-link>
                                                    <a v-else :href="item.url">{{item.label}}</a>
                                                    <img v-if="item.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 2px; margin-bottom: 2px;" />
                                                    <v-divider :class="isActive(item) ? 'active-tab' : 'inactive-tab'" class="my-1"/>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-menu v-else :close-on-content-click="true" :nudge-width="500"  :key="`menu-${index}`" content-class="center-aligned-menu" class="kt-menu__item kt-menu__item--submenu" :id="`_header_menu_${item.label.toLowerCase().replace(/\s+/g, '_')}`">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-list-item v-bind="attrs" v-on="on" class="kt-menu__link kt-menu__toggle mb-1" :class="$vuetify.breakpoint.width < 1024 ? 'px-2' : 'px-0'">
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{item.label}}
                                                            <img v-if="item.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 2px; margin-bottom: 2px;" />
                                                            <v-divider class="my-1" :class="item.children && item.children.some(child => child.children ? child.children.some(grandchild => isActive(grandchild)) : isActive(child)) ? 'active-tab' : 'inactive-tab'"/>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                            <v-card class="kt-menu__submenu kt-menu__submenu--fixed kt-menu__submenu--center">
                                                <v-card-text class="kt-menu__scroll">
                                                    <div class="kt-menu__subnav">
                                                        <div class="kt-menu__content">
                                                            <v-row no-gutters class="flex-nowrap" style="min-width: 50vw;">
                                                                <template v-for="(child, childIndex) in item.children">
                                                                <!-- Simple child items (no grandchildren) -->
                                                                <v-col v-if="!child.children" :key="`child-${index}-${childIndex}`" class="kt-menu__item">
                                                                    <v-list-item class="kt-menu__link">
                                                                        <v-list-item-content>
                                                                            <v-list-item-title>
                                                                                <router-link v-if="child.name" :to="buildRoute(child)">{{child.label}}</router-link>
                                                                                <a v-else :href="child.url">{{ child.label }}</a>
                                                                                <img v-if="child.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 5px;" />
                                                                            </v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-col>
                                                                
                                                                <!-- Child items with grandchildren (column headers) -->
                                                                <v-col v-else :key="`group-${index}-${childIndex}`" class="kt-menu__item">
                                                                    <!-- Column Header -->
                                                                    <span class="kt-menu__link-text">{{child.label}}</span>
                                                                    <!-- Column Items -->
                                                                    <v-list class="kt-menu__inner" dense>
                                                                        <v-list-item v-for="(grandchild, grandIndex) in child.children" :key="`grand-${index}-${childIndex}-${grandIndex}`" class="kt-menu__item px-0">
                                                                            <v-list-item-content class="kt-menu__link">
                                                                                <v-list-item-title>
                                                                                    <v-icon v-if="platform === 'nxlead'" small class="mr-2">{{grandchild.icon ? grandchild.icon : 'mdi-minus'}}</v-icon>
                                                                                    <router-link v-if="grandchild.name" :to="buildRoute(grandchild)">{{grandchild.label}}</router-link>
                                                                                    <a v-else :href="grandchild.url">{{grandchild.label}}</a>
                                                                                    <img v-if="grandchild.HJP && hasHJPlus" src="/images/logos/housejet/hj-plus-tiny-icon.png" height="15" style="margin-left: 5px;" />
                                                                                </v-list-item-title>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-col>
                                                                </template>
                                                            </v-row>
                                                        </div>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-list>
                            </div>
                        </v-col>
                        <v-col :style="$vuetify.breakpoint.mdAndUp ? 'padding: 4px 24px 12px 12px;' : ''">
                            <BadgeNavigation />
                        </v-col>
                    </template>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import getCurrentUserX from '@/mixins/getCurrentUserX'
import { FeatureFlags } from '@/options/featureFlags.js'
import BadgeNavigation from './badgeNavigation.vue';

export default {
    name: "MainNavigation",
    mixins: [getCurrentUserX],
    components: { BadgeNavigation },
    data(){
        return {
            drawer: false,
            tokenExists: !!localStorage.getItem('jwt_token'),
        }
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        currentUser() {
            this.tokenExists = !!localStorage.getItem('jwt_token');
        },
    },
    computed: {
        hasToken(){
           return this.tokenExists;
        },
        platform() {
            return this.currentUser?.client?.platform || 'ppc';
        },
        hasHJPlus() {
            return this.currentUserCanUse(FeatureFlags.KEY_HJ_PLUS) && !(this.currentUser && this.currentUser.house_jet_membership && this.currentUser.house_jet_membership.is_active)
        },
        isActive() {
            return (item) => {
                if (!item || !this.$route) return false;

                try {
                    if (item.name) {
                        if (this.$route.name !== item.name) return false;
                        if (item.query) {
                            return Object.keys(item.query).every(key => {
                                return this.$route.query[key] === item.query[key];
                            });
                        }
                        return true;
                    }

                    if (item.url) {
                        return window.location.pathname === item.url || this.$route.path === item.url;
                    }

                    if (typeof item === 'string') {
                        return window.location.pathname === item || this.$route.path === item;
                    }

                    return false;
                } catch (e) {
                    return false;
                }
            };
        },
        menuItems() {
            //variables needed for conditional rendering
            const user = this.currentUser;
            const isAdmin = user ? user.role : null;
            const product = user ? user.product : null;
            const menuItem=[];

            menuItem.push({ label: 'Dashboard', name: 'dashboard'});

            if (this.currentUserCanUse(FeatureFlags.KEY_PIPELINES) ) menuItem.push({ label: 'Pipeline', name: 'pipeline' });
            if ( this.currentUserCanUse(FeatureFlags.KEY_CONTACTS) ) menuItem.push({ label: 'Contacts', name: 'user-list' });

            if (this.platform === 'nxlead') {
                //PRODUCTIVITY
                const productivity = { label: 'Productivity', children: [] }
                    //Communication
                    const communication = { label: 'Communication', children: [] }
                    if ( this.currentUserCanUse(FeatureFlags.KEY_MAILBOX) )  communication.children.push({ label: 'Mailbox', name: 'mailbox', icon: 'flaticon-symbol' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_EMAIL_BLASTS)) {
                        communication.children.push({ label: 'Email Blasts', name: 'marketing-blast', icon: 'flaticon-graphic-1' })
                        communication.children.push({ label: 'Email Blast Templates', name: 'email-templates', query: {filter: 'Drip Campaign'}, icon: 'flaticon-multimedia' })
                        communication.children.push({ label: 'Email Templates', name: 'email-templates', icon: 'flaticon-multimedia' })
                    }
                    if (this.currentUserCanUse(FeatureFlags.KEY_AI_AGENT)) {
                        communication.children.push({ label: 'AI Dialer', name: 'ai-dialer-campaign', icon: 'flaticon-multimedia' })
                        communication.children.push({ label: 'AI Dialer Activity Log', name: 'ai-dialer-activity-log', icon: 'flaticon-multimedia' })
                    }
                    communication.children.push({ label: 'Behavioral Email Templates', url: '/agents/manageBehavioralEmailTemplates', icon: 'flaticon-multimedia' })
                    communication.children.push({ label: 'Sent Behavioral Emails', url: '/agents/viewSentBehavioralEmail', icon: 'flaticon-multimedia' })
                    productivity.children.push(communication)

                    //MLS Search
                    productivity.children.push({ label: 'MLS Search', name: 'mls-search', icon: 'flaticon-map' })

                    //Dialer
                    const dialer = { label: 'Dialer', children: [] }
                    dialer.children.push({ label: 'Campaigns', name: 'dialer-campaigns', icon: 'flaticon-support' })
                    dialer.children.push({ label: 'Dialer Music', url: '/agents/dialerMusic', icon: 'flaticon-music' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_VOICE_RECORDINGS)) dialer.children.push({ label: 'Voice Recordings', name: 'dialer-voice-recordings' })
                    if (isAdmin) {
                        dialer.children.push({ label: 'Dialer Report', url: '/administration/dialerCalledReport' })
                        dialer.children.push({ label: 'Minute Report', url: '/administration/minuteReport' })
                    }
                    productivity.children.push(dialer)

                    //Plans
                    const plans = { label: 'Plans', children: [] }
                    if (this.currentUserCanUse(FeatureFlags.KEY_AUTOMATIC_PLANS)) plans.children.push({ label: 'Automations', name: 'automation-view', icon: 'flaticon-list-3' })
                    plans.children.push({ label: 'Appointment Reminder Sequences', name: 'view-reminder-sequences', icon: 'flaticon-list-3' })
                    productivity.children.push(plans)

                    //Tasks
                    if (this.currentUserCanUse(FeatureFlags.KEY_TASKS)) {
                        const tasks = { label: 'Tasks', children: [] }
                        if (this.currentUserCanUse(FeatureFlags.KEY_CALENDAR)) tasks.children.push({ label: 'Calendar', name: 'calendar', icon: 'flaticon-time-2' })
                        if (this.currentUserCanUse(FeatureFlags.KEY_EVENTS)) tasks.children.push({ label: 'Events', name: 'events', icon: 'flaticon-time-2' })

                        //date calculations
                        const today = new Date()
                        const todayStr = today.toISOString().slice(0, 19).replace('T', ' ')
                        const todayDateStr = today.toDateString()
                        const todayDateStartStr = todayDateStr + ' 00:00:00'
                        const todayDateEndStr = todayDateStr + ' 23:59:59'
                        
                        const weekStartDate = new Date(today)
                        weekStartDate.setDate(weekStartDate.getDate() - weekStartDate.getDay() + 1)
                        const weekStart = weekStartDate.toISOString().slice(0, 19).replace('T', ' ')
                        
                        const weekEndDate = new Date(today)
                        weekEndDate.setDate(weekEndDate.getDate() - weekEndDate.getDay() + 6)
                        const weekEnd = weekEndDate.toISOString().slice(0, 19).replace('T', ' ')
                        
                        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 19).replace('T', ' ')
                        const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59).toISOString().slice(0, 19).replace('T', ' ')
                        
                        tasks.children.push({ label: 'Overdue Tasks', name: 'tasks', query: {status: 'P', date_type: 'date', end: todayStr}, icon: 'flaticon2-warning' })
                        tasks.children.push({ label: 'All Tasks', name: 'tasks', icon: 'flaticon-list' })
                        tasks.children.push({ label: "Today's Tasks", name: 'tasks', query: {date_type: 'date', start: todayDateStartStr, end: todayDateEndStr}, icon: 'flaticon-calendar' })                        
                        tasks.children.push({ label: "This Week's Tasks", name: 'tasks', query: {date_type: 'date', start: weekStart, end: weekEnd}, icon: 'flaticon-calendar-1' })
                        tasks.children.push({ label: "This Month's Tasks", name: 'tasks', query: {date_type: 'date', start: monthStart, end: monthEnd}, icon: 'flaticon-calendar-2' })
                        productivity.children.push(tasks)
                    }
                
                menuItem.push(productivity)

                //MARKETING
                const marketing = { label: 'Marketing', children: [] }
                    //Website
                    const website = { label: 'Website', children: [] }
                    //website.children.push({ label: `${this.currentUser?.brand_co_name || 'NxLead'} Pages`, url: '/agents/squeezePage', icon: 'flaticon-technology-2' })
                    //website.children.push({ label: 'Page Builder ( Beta )', name: 'marketing-custom-pages', icon: 'flaticon-profile' })
                    website.children.push({ label: 'Property Landing Pages', url: '/agents/searchLanding', icon: 'flaticon-home-2' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_BLOGS)) website.children.push({ label: 'Blogs', name: 'marketing-blogs', icon: 'flaticon2-bell-4' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_VIDEOS)) website.children.push({ label: 'Videos', name: 'marketing-videos', icon: 'flaticon-photo-camera' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_WEBSITES)) website.children.push({ label: 'Testimonials', name: 'housejet-website-testimonials', icon: 'flaticon-notes' })
                    website.children.push({ label: 'Surveys', name: 'marketing-surveys' })
                    website.children.push({ label: 'Framed Content', url: '/agents/wrapAddress' })
                    website.children.push({ label: 'Domains', name: 'marketing-domains' })
                    marketing.children.push(website)

                    // Digital Advertising
                    if (this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_LEAD_GEN) || this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_RETARGETING) || this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_SMART_LISTS)) {
                        const digital = { label: 'Digital Advertising', children: [] }
                        digital.children.push({ label: 'Campaigns', name: 'marketing-campaigns' })
                        if (this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_SMART_LISTS)) digital.children.push({ label: 'Smart Lists', name: 'marketing-smart-lists' })
                        marketing.children.push(digital)
                    }

                    // MLS
                    const mls = { label: 'MLS', children: [] }
                    mls.children.push({ label: 'MLS Search', name: 'mls-search', icon: 'flaticon-home-2' })
                    mls.children.push({ label: 'Saved Searches', url: '/agents/savedSearchUrlList' })
                    mls.children.push({ label: 'Reverse Searches', url: '/agents/reverseSearch' })
                    mls.children.push({ label: 'Seller Reverse Searches', name: 'seller-reverse-search' })
                    mls.children.push({ label: 'Featured Properties', url: '/agents/featuredHomeList' })
                    mls.children.push({ label: 'Listing Office', url: '/agents/officeHomeList' })
                    marketing.children.push(mls)

                if (marketing.children.length > 0) menuItem.push(marketing)

                //REPORTING
                const reporting = { label: 'Reporting', children: [] }
                    //Reports
                    const reports = { label: 'Reports', children: [] }
                    reports.children.push({ label: 'Agent Activity Chart', url: '/agents/agentActivityStatistic', icon: 'flaticon-diagram' })
                    reports.children.push({ label: 'Price Range Report', url: '/agents/report', icon: 'flaticon-graph' })
                    reports.children.push({ label: 'Sales History', name: 'sales-history', icon: 'flaticon-buildings' })

                    if (isAdmin) {
                        reports.children.push({ label: 'ISA Leads', url: '/administration/isaLeadsReport', icon: 'flaticon-users' })
                        reports.children.push({ label: 'UTM Report', url: '/agents/utmReport' })
                        reports.children.push({ label: 'Origin Report', name: 'origin-report', icon: 'flaticon2-website' })
                    }

                    reports.children.push({ label: 'Lead Source Report', name: 'report-lead-source', icon: 'flaticon2-list-2' })
                    reports.children.push({ label: 'Task Disposition Report', name: 'report-task-disposition', icon: 'flaticon2-website' })
                    reports.children.push({ label: 'Task Call Report', name: 'report-task-calls', icon: 'flaticon2-website' })
                    reporting.children.push(reports)

                    //Money Score
                    const moneyScore = { label: 'Money Score', children: [] }
                    moneyScore.children.push({ label: 'Dashboard', url: '/agents/moneyScoreDashboard', icon: 'flaticon-map' })
                    moneyScore.children.push({ label: 'Leader Board', url: '/agents/moneyScoreLeaderboard', icon: 'flaticon-trophy' })
                    moneyScore.children.push({ label: 'Live', url: '/agents/moneyScoreLive', icon: 'flaticon-rocket' })
                    moneyScore.children.push({ label: 'History', url: '/agents/moneyScoreHistory', icon: 'flaticon-calendar-with-a-clock-time-tools' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_TEAMS)) moneyScore.children.push({ label: 'Teams', url: '/agents/moneyScoreTeams', icon: 'flaticon-users' })
                    moneyScore.children.push({ label: 'Settings', url: '/agents/moneyScoreSettings', icon: 'flaticon-user-settings' })
                    reporting.children.push(moneyScore)

                menuItem.push(reporting)

                //ADMINISTRATION
                if (isAdmin) {
                    const administration = { label: 'Administration', children: [] }

                    //Contacts
                    const contacts = { label: 'Contacts', children: [] }
                    contacts.children.push({ label: 'Bulk Reassign', url: '/administration/bulkReassignLeads', icon: 'flaticon-network' })
                    contacts.children.push({ label: 'Lead Profile Settings', url: '/administration/leadProfileSettings', icon: 'flaticon-user-settings' })
                    contacts.children.push({ label: 'Lead Types', name: 'admin-lead-types' })
                    contacts.children.push({ label: 'Distribution Settings', name: 'administration-distribution-settings', icon: 'flaticon-network' })
                    contacts.children.push({ label: 'Lead Pools', name: 'admin-lead-pool' })
                    contacts.children.push({ label: 'Merge Duplicates', url: '/administration/destructiveDuplicateMerge', icon: 'flaticon-users' })
                    contacts.children.push({ label: 'Contact Tags', name: 'admin-user-tags', icon: 'flaticon-delete' })
                    administration.children.push(contacts)

                    //Automation
                    const automation = { label: 'Automation', children: [] }
                    automation.children.push({ label: 'Task Dispositions Report', url: '/administration/tasksDispositionReport', icon: 'flaticon-calendar-3' })
                    automation.children.push({ label: 'Disposition Settings', name: 'tasks-dispositions', icon: 'flaticon-calendar-3' })
                    administration.children.push(automation)

                    //Productivity
                    const adminProductivity = { label: 'Productivity', children: [] }
                    adminProductivity.children.push({ label: 'Money Score Users', url: '/administration/moneyScoreUsers', icon: 'flaticon-users' })
                    adminProductivity.children.push({ label: 'Dialer Settings', url: '/administration/dialerSettings', icon: 'flaticon-support' })
                    adminProductivity.children.push({ label: 'Callback Scripts', url: '/administration/callScripts' })
                    administration.children.push(adminProductivity)

                    //Marketing
                    const adminMarketing = { label: 'Marketing', children: [] }
                    adminMarketing.children.push({ label: 'Interest Landing Pages', url: '/administration/interestsLandingPages', icon: 'flaticon-laptop' })
                    adminMarketing.children.push({ label: 'Custom Pages', url: '/administration/customPages', icon: 'flaticon-laptop' })
                    adminMarketing.children.push({ label: 'Blog Import', url: '/administration/blogRssImport' })
                    adminMarketing.children.push({ label: 'Blog Settings', url: '/administration/blogSettings' })
                    adminMarketing.children.push({ label: 'Featured Property Settings', url: '/administration/featuredSettings' })
                    adminMarketing.children.push({ label: 'Website Settings', name: 'website-settings', icon: 'flaticon-laptop' })
                    administration.children.push(adminMarketing)

                    //Users
                    const users = { label: 'Users', children: [] }
                    users.children.push({ label: 'User List', name: 'admin-users' })
                    users.children.push({ label: 'User Groups', url: '/administration/viewUserType' })
                    users.children.push({ label: 'Lead Statuses', url: '/agents/manageLeadStatusTypes' })
                    administration.children.push(users)

                    menuItem.push(administration)
                }

            } else { // HouseJet/PPC Platform
                
                //PRODUCTIVITY
                const productivity = { label: 'Productivity', children: [] }
                    //Tasks
                    if (this.currentUserCanUse(FeatureFlags.KEY_TASKS)) {
                        const tasks = { label: 'Tasks', children: [] }
                        tasks.children.push({ label: 'Tasks', name: 'tasks' })
                        if (this.currentUserCanUse(FeatureFlags.KEY_CALENDAR)) tasks.children.push({ label: 'Calendar', name: 'calendar' })
                        if (this.currentUserCanUse(FeatureFlags.KEY_EVENTS)) tasks.children.push({ label: 'Events', name: 'events' })
                        productivity.children.push(tasks)
                    }

                    //Communication
                    const communication = { label: 'Communication', children: [] }
                    if (this.currentUserCanUse(FeatureFlags.KEY_EMAIL_BLASTS)) {
                        communication.children.push({ label: 'Email Blasts', name: 'marketing-blast', HJP: true })
                        communication.children.push({ label: 'Email Templates', name: 'email-templates', HJP: true })
                    }
                    if (this.currentUserCanUse(FeatureFlags.KEY_AI_AGENT)) {
                        communication.children.push({ label: 'AI Dialer', name: 'ai-dialer-campaign', icon: 'flaticon-multimedia'})
                        communication.children.push({ label: 'AI Dialer Activity Log', name: 'ai-dialer-activity-log', icon: 'flaticon-multimedia'})
                    }
                    if (this.currentUserCanUse(FeatureFlags.KEY_MAILBOX)) communication.children.push({ label: 'Mailbox', name: 'mailbox' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_BLOGS)) communication.children.push({ label: 'Blogs', name: 'marketing-blogs', HJP: true })
                    if (this.currentUserCanUse(FeatureFlags.KEY_VIDEOS)) communication.children.push({ label: 'Videos', name: 'marketing-videos', HJP: true })
                    if (this.currentUserCanUse(FeatureFlags.KEY_VOICE_RECORDINGS)) communication.children.push({ label: 'Voice Recordings', name: 'dialer-voice-recordings', HJP: true })
                    if (this.currentUserCanUse(FeatureFlags.KEY_AUTOMATIC_PLANS)) communication.children.push({ label:'Automations', name: 'automation-view', HJP: true })
                    if (this.currentUserCanUse(FeatureFlags.KEY_SAVED_SEARCHES)) communication.children.push({ label: 'MLS Search', name: 'mls-search', icon: 'flaticon-home-2' })
                    communication.children.push({ label: 'Appointment Reminder Sequences', name: 'view-reminder-sequences', HJP: true })
                    productivity.children.push(communication)

                menuItem.push(productivity)

                //MARKETING
                const marketing = { label: 'Marketing', children: [] }

                    //Pay Per Closing
                    const payPerClosing = { label: 'Pay Per Closing', children: [] }

                        //Marketing
                        if (this.currentUserCanUse(FeatureFlags.KEY_REFERRAL_MARKETING)) {
                            const marketingTitle = user.house_jet_signup?.referral ? 'Referral Marketing' : 'Marketing Setup'
                            payPerClosing.children.push({ label: marketingTitle, name: 'housejet-marketing' })
                        }

                        //Social Branding
                        if (this.currentUserCanUse(FeatureFlags.KEY_SOCIAL_BRANDING)) payPerClosing.children.push({ label: 'Social Branding', name: 'marketing-branding', HJP: user.is_free })
                        if (this.currentUserCanUse(FeatureFlags.KEY_WEBSITES)) payPerClosing.children.push({ label: 'Testimonials', name: 'housejet-website-testimonials' })
                    marketing.children.push(payPerClosing)

                    //Digital Advertising
                    if (this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_LEAD_GEN) || this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_RETARGETING) || this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_SMART_LISTS)) {
                        const digital = { label: 'Digital Advertising', children: [] }
                        if (this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_LEAD_GEN) || this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_RETARGETING))  digital.children.push({ label: 'Additional Marketing', name: 'marketing-campaigns', HJP: true })
                        if (this.currentUserCanUse(FeatureFlags.KEY_ADDITIONAL_MARKETING_SMART_LISTS)) digital.children.push({ label: 'Smart Lists', name: 'marketing-smart-lists', HJP: true })
                        marketing.children.push(digital)
                    }

                menuItem.push(marketing)

                if (this.currentUserCanUse(FeatureFlags.KEY_UNIVERSITY)) menuItem.push({ label: 'University', name: 'learning-center', url: '/agents/learningCenter/index' })

                if (this.currentUserCanUse(FeatureFlags.KEY_TEAMS)) menuItem.push({ label: 'Teams', name: 'teams', HJP: true })

                if (this.currentUserCanUse(FeatureFlags.KEY_PROSPECT_LIST)) menuItem.push({ label: 'Prospect List', name: 'prospects' })
            }

            // PROFILE
            const profileAccount = { label: 'Profile and Account', children: [], MobileOnly: true }
            profileAccount.children.push({ label: 'My Profile', name: 'user-profile' })
            if (this.currentUserCanUse(FeatureFlags.KEY_CONNECTED_ACCOUNTS)) profileAccount.children.push({ label: 'Connected Accounts', name: 'connected-accounts' })
            if (this.currentUserCanUse(FeatureFlags.KEY_MY_FILES)) profileAccount.children.push({ label: 'My Files', name: 'agent-files' })
            
                // Nxlead
                if (this.platform === 'nxlead') {
                    profileAccount.children.push({ label: 'My Messages', name: 'mailbox' })
                    if (isAdmin) profileAccount.children.push({ label: 'Settings', name: 'settings-admin' })
                    profileAccount.children.push({ label: 'Billing', name: 'housejet-billing-profile' })
                }
            
                // HouseJet
                if (this.platform === 'housejet' && !user.super_admin && this.currentUserCanUse(FeatureFlags.KEY_BILLING))  profileAccount.children.push({ label: 'Billing', name: 'ppc-billing' })

                // PPC
                if (this.platform === 'ppc') {
                    if (this.currentUserCanUse(FeatureFlags.KEY_HJ_PLUS)) profileAccount.children.push({ label: 'HOUSEJET+', name: 'housejet-plus' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_COMMISSION_SHARE_PROGRAM)) profileAccount.children.push({ label: 'Commission Share Program', name: 'commission-share' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_SERVICE_AREAS)) profileAccount.children.push({ label: 'Service Areas', name: 'service-areas' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_WEBSITES)) profileAccount.children.push({ label: 'Website', name: 'housejet-website-setup' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_USAGE)) profileAccount.children.push({ label: 'Usage', name: 'usage' })
                    if (this.currentUserCanUse(FeatureFlags.KEY_BILLING)) profileAccount.children.push({ label: 'Billing', name: 'ppc-billing' })
                }

            menuItem.push(profileAccount)

            // Sign Out
            menuItem.push({ label: 'Sign Out', name: 'prelogout', MobileOnly: true })

            return menuItem
        },
        FeatureFlags(){ return FeatureFlags },
    },
    methods: {
        toggleDrawer(){
            this.drawer = !this.drawer;
        },
        buildRoute(item) {
            const route = { name: item.name };

            if (item.query && typeof item.query === 'object') {
                route.query = { ...item.query };
            }

            return route;
        }
    }
}
</script>

<style scoped>
::v-deep .v-list-group__header__prepend-icon {
    display: none !important;
}

::v-deep .v-list-item-action .v-icon {
    transition: transform 0.3s ease;
}

::v-deep .v-list-group--no-action .v-list-group__items .v-list-item{
    padding-left: 24px !important;
}

.center-aligned-menu{
    left: 50% !important;
    transform: translateX(-50%) !important;
    top: 70px !important;
}

.kt-menu__item.active .kt-menu__link .v-list-item-title {
    color: var(--primary-color) !important;
}

.kt-menu__item:not(.active) .kt-menu__link .v-list-item-title, a {
    color: var(--secondary-text) !important;
}

.v-navigation-drawer >>> .v-navigation-drawer__border {
  display: none;
}

.active-tab{
    border-color: var(--primary-color) !important;
    border-width: 1px !important;
}

.inactive-tab{
    border-color: transparent !important;
    border-width: 1px !important;
}

::v-deep .theme--light.v-list-item:focus:before, .theme--light.v-list-item:hover:before{
    opacity: 0 !important;
}

.kt-menu__link-text{
    font-weight: var(--font-weight-secondary) !important;
    font-size: 1.07rem !important;
    text-transform: initial;
}

.kt-menu__link .v-ripple__container{
    display: none !important;
}

::v-deep .v-list-item__title{
    overflow: revert !important;
}
</style>